import React, { useState } from 'react';
import { auth } from '../firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { FaGoogle } from 'react-icons/fa';

const Login = () => {
  const [error, setError] = useState(null);

  const signInWithGoogle = async () => {
    try {
      const provider = new GoogleAuthProvider();
      // Configurações adicionais para o login
      provider.setCustomParameters({
        'login_hint': 'user@example.com'
      });
      
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error('Detalhes completos do erro:', error);
      
      // Mapeamento de erros comuns
      switch (error.code) {
        case 'auth/configuration-not-found':
          setError('Configuração do Firebase não encontrada. Verifique as configurações.');
          break;
        case 'auth/popup-blocked':
          setError('O popup de login foi bloqueado. Habilite popups para este site.');
          break;
        case 'auth/popup-closed-by-user':
          setError('Login cancelado pelo usuário.');
          break;
        default:
          setError(`Erro ao fazer login: ${error.message}`);
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
      <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg max-w-sm w-full">
        <h1 className="text-2xl font-bold text-center mb-8 text-gray-900 dark:text-white">
          Meeting Transcription
        </h1>
        
        <button
          onClick={signInWithGoogle}
          className="w-full flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-900 font-semibold py-3 px-4 border border-gray-300 rounded-lg shadow-sm transition-all duration-200 hover:shadow-md"
        >
          <FaGoogle className="text-[#4285F4]" />
          <span>Entrar com Google</span>
        </button>
        
        {error && (
          <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
            {error}
          </div>
        )}
        
        <p className="mt-4 text-sm text-center text-gray-600 dark:text-gray-400">
          Faça login para começar a transcrever suas reuniões
        </p>
      </div>
    </div>
  );
};

export default Login;
